export default "__VITE_ASSET__DtPId22m__"